export function initialise() {
    return Promise.resolve(true);
}
